import { Link } from "react-router-dom";
import { ImageLink } from "../constants";
import "./GatewayCard.scss";
const GatewayCard = ({ questionSubject, image1, subjectUrl }) => {
  const finalImage = image1 ? ImageLink(image1) : null;
  return (
    <Link to={`/subject/${subjectUrl}`} className="subject-link">
      <div className="subject-card">
        <div className="subject-card-icon">
        {finalImage && (
            <img src={ImageLink(image1)} alt={questionSubject}/>
          )}
          </div>
        <div className="subject-card-title">
          <h3>{questionSubject}</h3>
        </div>
      </div>
    </Link>
  );
};

export default GatewayCard;
